/* eslint-disable  */
// open external links in new tab

function isFileLink(url) {
  const fileExtensions = ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'csv', 'jpg', 'jpeg', 'png', 'gif'];

  const urlParts = url.split('.');
  const extension = urlParts[urlParts.length - 1].toLowerCase();

  return fileExtensions.includes(extension);
}

function openExternalLink() {
  window.addEventListener('load', () => {
    document.querySelectorAll('a[href]:not(.button):not(.no-icon):not(.lexicon-term)').forEach((item) => {
      if (window.location.hostname !== new URL(item.href).hostname && !isFileLink(item.href)) {
        item.target = '_blank';
        item.rel = 'noreferrer nofollow noopener';
        item.classList.add('is-external-link');
        item.insertAdjacentHTML(
          'beforeend',
          `<span class="external-icon" focusable="false" aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
          <path d="M14.2188 2.25H10.2188M14.2188 2.25L8.21875 8.25M14.2188 2.25V6.25" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M14.2188 8.91667V12.9167C14.2188 13.2703 14.0783 13.6094 13.8282 13.8595C13.5782 14.1095 13.239 14.25 12.8854 14.25H3.55208C3.19846 14.25 2.85932 14.1095 2.60927 13.8595C2.35923 13.6094 2.21875 13.2703 2.21875 12.9167V3.58333C2.21875 3.22971 2.35923 2.89057 2.60927 2.64052C2.85932 2.39048 3.19846 2.25 3.55208 2.25H7.55208" stroke="#333333" stroke-width="1.5" stroke-linecap="round"/>
          </svg></span> `,
        );
      }
    });
  });
}

openExternalLink();

function setVhUnit() {
  let vh = window.innerHeight * 0.01;

  document.documentElement.style.setProperty('--vh', `${vh}px`);

  // We listen to the resize event
  window.addEventListener('resize', () => {
    vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  });
}

setVhUnit();
